import { BetBuilderStates, BetSlipStates, OddsType } from "app/utils/const";

export class BetBuilderHelper {
  static hasItemsMatchingCondition(items, condition) {
    return items.some((_, index) => condition(index));
  }

  static getRedundantItems(items, condition) {
    return items.filter((_, index) => condition(index));
  }

  static removeAllRedundantItems(event, dispatch, condition) {
    const redundantItems = this.getRedundantItems(
      event.betBuilderItems,
      condition
    );

    if (redundantItems.length > 0) {
      dispatch.betBuilderModel.removeRedundantBetBuilderItems({
        eventId: event.eventId,
        itemsToRemove: redundantItems,
      });
    }
  }

  static shouldShowRedundantButton(event) {
    const selections = event?.selections || [];
    return this.hasItemsMatchingCondition(
      event.betBuilderItems,
      index =>
        selections[index]?.outcome?.status === BetBuilderStates.UNAVAILABLE
    );
  }

  static shouldShowLockButton(event) {
    return this.hasItemsMatchingCondition(
      event.betBuilderItems,
      () => event?.errorMessage?.status === BetBuilderStates.UNAVAILABLE
    );
  }
}
// Function to construct payload for the bet slip
export const constructPayload = (
  eventId: number,
  multipleBetResponse: {
    message: string;
    status: string;
    requestId: string;
  }
) => {
  const payload: {
    eventId: number;
    message: string;
    submitting: boolean;
    requestId: string;
    status?: string;
  } = {
    eventId,
    message: multipleBetResponse.message,
    submitting: false,
    requestId: multipleBetResponse.requestId,
  };

  // Conditionally add the status property
  if (multipleBetResponse.status === BetSlipStates.FAILED) {
    payload.status = multipleBetResponse.status;
  }

  return payload;
};

export const getPlusSign = (
  oddsType: string,
  calculatedOdds?: number
): string => {
  return oddsType === OddsType.US &&
    calculatedOdds !== undefined &&
    calculatedOdds >= 0
    ? "+"
    : "";
};
